import React from 'react'
import HomeBarner from '../../components/web/home/HomeBarner'
import HomeEcommerce from '../../components/web/home/HomeEcommerce';
import HomeAbout from '../../components/web/home/HomeAbout';
import BenefitsSection from '../../components/web/home/BenefitsSection';
import HomeService from '../../components/web/home/HomeService';
import HomeTestimonial from '../../components/web/home/HomeTestimonial';


const HomePage = () => {
    return (
        <div className="page-content bg-white" style={{ overflow:"hidden" }}>

            <HomeBarner />
            {/* <HomeAbout/> */}
            <HomeEcommerce />
            <HomeService/>
            <HomeTestimonial/>
            {/* <BenefitsSection/> */}
            {/*<HomeAbout/> */}

        </div>
    )
}

export default HomePage
